
/*
*
* File JS per la Archive Charter
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSingle from 'components/heroes/hero-single';
import blockTitle from 'components/block-title/block-title';

import listCharter from 'components/charter/list-charter'; 
import listYacht from 'components/yacht/list-yacht';
import cardYacht from 'components/yacht/card-yatch';


//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-charter.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    listCharter();
});

//--------------------------------------------------------------------//